import React, { useEffect, useState } from 'react';
import axios from 'axios';
import parse from "html-react-parser";
import { Link, useNavigate } from "react-router-dom"; // تأكد من إضافة Link هنا
import { variables } from './Variables.js';

export default function CricketHome() {
  const jsonCricketUrl = variables.basename_url + 'updates/index/Athlethixnet_HomeEn_Cricket.json';

  const [isLoading, setIsLoading] = useState(false);
  const [JsonCricketArray, setJsonCricketArray] = useState([]);
  const navigate = useNavigate();

  async function fetchCricketData() {
    setIsLoading(true);
    try {
      const response = await axios.get(jsonCricketUrl);
      const tempArray = [];

      for (let i = 0; i < 4 && i < response.data.length; i++) {
        tempArray.push({
          news_title: response.data[i].news_title,
          news_date: response.data[i].news_date,
          Image: response.data[i].Image,
          link: response.data[i].link,
          Category: response.data[i].Category,
          // Description: response.data[i].Description
          //   .replace("https://menafn.com/", variables.domain_name + "/")
          //   .replace("https://menafn.com", variables.domain_name)
          //   .replace(/MENAFN/g, variables.domain),
          //Aya Added these replaces:
          Description: response.data[i].Description
            .replace(/<iframe.*?<\/iframe>/gi, "")
            .replace("MENAFN", variables.domain)
            .replace(/<p.*?<\/p>/gi, "")
            .replace(/<br.*?<\/br>/gi, "")
            .replace(/<strong.*?<\/strong>/gi, ""),
        });
      }

      setJsonCricketArray(tempArray);
      setIsLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchCricketData();
  }, []);

  const formatDate = (dateStr) => {
    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('ar-EG');
  };

  return (
    <>
      <div className="bussiness-box mt-40">
        <div className="section-title">
          <a href="/Cricket">
            <h3 className="title">Cricket News</h3>
          </a>
        </div>


        <div className="bussiness-items" style={{ display: 'grid', gap: '20px' }}>
          {JsonCricketArray.map((C, index) => (
            <div key={index} className="bussiness-post-item" style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              borderBottom: '1px solid #eee',
              paddingBottom: '15px'
            }}>

              <div className="bussiness-post-thumb">
                <Link to={C.link.replace(variables.domain_name, "")}
                >
                  <img
                    className='rounded'
                    style={{ width: '100%', maxWidth: '400px', height: 'auto', display: 'block' }}
                    src={C.Image}
                    alt={C.news_title}
                  />
                </Link>
              </div>

              <div className="bussiness-post-content" style={{ padding: '0 5px' }}>
                <span style={{ fontSize: '12px', color: '#888', display: 'block', marginBottom: '5px' }}>
                  {/* {formatDate(C.news_date)} */}
                  {C.news_date}
                </span>

                <h3 className="title1" style={{ margin: '0 0 8px 0', fontSize: '1.2rem', lineHeight: '1.4' }}>
                  <Link to={C.link.replace(variables.domain_name, "")}
                    style={{ color: '#333', textDecoration: 'none', fontWeight: 'bold' }}>
                    {C.news_title}
                  </Link>
                </h3>

                <div className="description-text" style={{ fontSize: '14px', color: '#555' }}>
                  {parse(C.Description)}
                </div>
              </div>

            </div>
          ))}
        </div>
      </div>
    </>
  );
}